import React from "react"
import { omit } from "lodash"

export default (Tag, filter = []) => {
  return props => <Tag {...omit(props, filter)} />
}
